/*eslint-disable */
"use strict";

(function() {
  require("../libraries/doc-ready/docready");

  window.docReady(function() {
    require("./home/searchMaskTabs").init();

    require("./home/searchBackBtn").init();

    require("./home/trucksSearch").init();

    require("./home/searchMaskViewChange").init();
  });
})();
